module.exports = __webpack_public_path__ + "img/qhcy_logo.9180295a.jpg";